const Badge = ({ background, color, label }) => {
  return (
    <div className={`py-1 px-2 text-xs rounded-xl ${background} ${color}`}>
      {label}
    </div>
  )
}

export default Badge
